import NidApp from "./api.js";
import datepicker from "./datepicker";

Date.prototype.yyyymmdd = function() {
	let mm = this.getMonth() + 1; // getMonth() is zero-based
	let dd = this.getDate();

	return [this.getFullYear(),
		(mm>9 ? '' : '0') + mm,
		(dd>9 ? '' : '0') + dd
	].join('-');
};


;(function ($, nordsjo) {

	$(function () {

		var $wishList = $(document.getElementById('wishlist-prod-list')),
			$wishListActions = $('.wishlist-user-actions'),
			$wishListStore = $('.selected-store'),
			$emailForm = $(document.getElementById('email-wishlist')),
			$flexslider = $(document.getElementById('related-products-carousel'));

		$wishList
			.on('click', 'a.wl-action', function (e) {
				e.preventDefault();

				var $this = $(this),
					$input = $this.parent().find('input.wishlist-num-prod'),
					$print = $this.parent().prev().find('.print-only .amt'),
					val = +$input.val(),
					newVal;

				if ($this.hasClass('plus')) {
					newVal = val + 1;

				} else if ($this.hasClass('minus')) {
					if (val > 0) {
						newVal = val - 1;
					} else {
						newVal = val;
					}
				}

				$input.val(newVal);
				$print.text(newVal);
				updateTotals();
			})
			.on('click', 'a.remove-wishlist-prod', function (e) {
				e.preventDefault();
				NidApp.showLoadingIcon();

				var $this = $(this),
					data = {
						wisthlist_item_id: $this.data('wishlist-item-id'),
						action: 'delete-wishlist-item',
						security: nordsjo.ajaxNonce
					};

				$.ajax({
					type: 'POST',
					url: nordsjo.ajaxurl,
					data: data
				}).done(function (result) {
					NidApp.removeLoadingIcon();

					if (true === result.success) {
						NidApp.showMessage(result.data.message);
						$this.closest('li').fadeOut(200, function () {
							$(this).remove();
							wishlistCheckIfEmpty();
							updateTotals();
						});
						NidApp.updateWishlistItemCount(true);
					} else {
						NidApp.showMessage(result.data.message, 'error');
					}
				});
			})
			.on('change', '.wishlist-num-prod', function (e) {
				updateTotals();
			});

		$wishListActions
			.on('change', 'input', function (e) {
				$(e.target).addClass('entered');
				validateEmailForm();
			})
			.on('click', 'button.pdf', function (e) {
				e.preventDefault();
				$('#wishlist-print').val(true);
				$(this).submit();
			});

		$wishListStore
			.on('click', '.change-store', function (e) {
				e.preventDefault();

				nordsjo.showStorePicker('change-store');
			});

		$(document.getElementById('wishlist')).on('submit', function (e) {
			e.preventDefault();

			$.ajax({
				type: 'POST',
				url: nordsjo.ajaxurl,
				data: {
					'action': 'update-wishlist',
					'form': $(this).serialize(),
					'security': nordsjo.ajaxNonce
				}
			}).done(function (response) {
				var message = response.data.message;
				NidApp.showMessage(message);
			});
		});


		$(document.getElementById('email-wishlist')).on('submit', function (e) {
			var $this = $(this);

			var order = {
				'products': JSON.parse($this.find('#wishlist-order').val()),
				'userName': $this.find('#wishlist-user-name').val(),
				'userEmail': $this.find('#wishlist-user-email').val(),
				'userPhone': $this.find('#wishlist-user-phone').val(),
				'userPhone': $this.find('#wishlist-user-phone').val(),
				'userPickupDate': $this.find('#wishlist-user-pickup-date').val(),
				'storeId': $this.find('#wishlist-store-id').val(),
				'storeName': $this.find('#wishlist-store-name').val(),
				'storeAddress': $('.selected-store .store-address').html(),
				'storeEmail': $this.find('#wishlist-store-email').val(),
				'storePhone': $this.find('#wishlist-store-phone').val(),
				'storeComments': $this.find('#wishlist-store-comments').val(),
				'storeURL': $this.find('#wishlist-store-url').val(),
			};

			e.preventDefault();
			$.ajax({
				type: 'POST',
				url: nordsjo.ajaxurl,
				data: {
					'action': 'email-wishlist',
					'order': order,
					'security': nordsjo.ajaxNonce,
				}
			}).done(function (response) {
				var message = response.data.message;
				NidApp.showMessage(message);

				$('.wishlist-headers').remove();
				$('#wishlist').remove();
				$('#email-wishlist').remove();
				$('.wishlist-user-actions').remove();
				$('.change-store').remove();
				$('#wishlist-counter').html('0');
				$('.thank-you-message').show();
			});
		});


		function wishlistCheckIfEmpty() {
			if (!$('li', $wishList).length) {
				$('.wishlist-container').html('<p>' + nordsjo.emptyWishlist + '</p>');
				$('.related-prod-cont').empty();

			}
		}


		function updateTotals() {
			var $rows = $('li.item', $wishList);
			var total = 0;

			_.each($rows, function (row) {
				var $row = $(row);
				var id = $row.data('wishlist-id');
				var price = parseFloat($('input[name=wishlist-' + id + '-price]', $row).val());
				var quantity = parseInt($('.wishlist-num-prod', $row).val());
				var row_total = price * quantity;
				$('.row-total', $row).html(row_total);

				total += row_total;
			});

			$('.sum-total', $wishList).html(total);
		}


		function validateEmailForm() {
			var $emailButton = $('button.email-link');
			var $name = $('#wishlist-user-name', $emailForm);
			var $email = $('#wishlist-user-email', $emailForm);
			var $phone = $('#wishlist-user-phone', $emailForm);
			var $terms = $('#agreed-to-terms', $emailForm);
			var $order = $('#agreed-to-order-terms', $emailForm);
			var $paints = $('#agreed-to-broken-paint', $emailForm);
			var valid = true;
			var validEmail = true;

			if ($name.val() === '' && $name.hasClass('entered')) {
				valid = false;
				$name.addClass('invalid');
			} else {
				$name.removeClass('invalid');
			}

			if ($email.val() === '' && $email.hasClass('entered')) {
				valid = false;
				$email.addClass('invalid');
			} else {
				$email.removeClass('invalid');
			}

			if ($phone.val() === '' && $phone.hasClass('entered')) {
				valid = false;
				$phone.addClass('invalid');
			} else if ($phone.val() === '') {
				valid = false;
			} else {
				$phone.removeClass('invalid');
			}

			if (validateEmail($email.val()) === false) {
				validEmail = false;
				valid = false;
			}

			if ($terms.prop('checked') === false) {
				valid = false;
			}

			if ($order.prop('checked') === false) {
				valid = false;
			}

			if (false === validEmail) {
				$email.addClass('invalid');
			} else {
				$email.removeClass('invalid');
			}

			if (true === valid) {
				$emailButton.attr('disabled', false);
			} else {
				$emailButton.attr('disabled', true);
			}
		}


		function validateEmail($email) {
			var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
			return emailReg.test($email);
		}

		$flexslider.flexslider(NidApp.getProductSliderArgs($flexslider, true));

		$( document ).ready( function() {
			let $datepicker = $('#wishlist-user-pickup-date');
			if ( $datepicker.length > 0 ) {
				const datePicker = datepicker('#wishlist-user-pickup-date', {
						customDays: nordsjo.tWeekDays,
						customMonths: nordsjo.tMonths,
						minDate: new Date(),
						disableYearOverlay: true,
						formatter: (input, date, instance) => {
							input.value = date.yyyymmdd();
						}
					}
				);
			}
		});

	});

}(jQuery, nordsjo));
